import React, { useEffect } from 'react';
import { useOutletContext } from 'react-router';
import Avatar from '@mui/material/Avatar';
import Button from '@Components/Button';
import Dropdown from '@Components/Dropdown';
import AppBar from '@Components/AppBar';
import IconBanner from '@Components/IconBanner';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import ShieldImg from 'assets/images/shield.svg';
import { useBrowserHistory } from '@Utilities/services/hooks/useBrowserHistory';
import { getRelationshipOptions } from './services';
import { logComponentEvent } from '@Utilities/services/logging/componentEvent';
import shortid from 'shortid';
import { getInitials } from '@Utilities/services/name';
import './styles/giftCompliance.scss';

function GiftCompliance() {
  const browserHistory = useBrowserHistory();

  const {
    localized,
    beneficiary,
    relationship,
    relationshipError,
    updateRelationship,
    onComplianceNext,
    selectedOccasion
  } = useOutletContext();

  const { profilePictureUrl, firstName, lastInitial } = beneficiary || {};

  useEffect(() => {
    logComponentEvent('GiftingRelationship', 'PageLoaded');
  }, []);

  return (
    <div className='gift-compliance'>
      <AppBar
        title={localized['giftCompliance.title'] || ''}
        onBackClick={() => {
          browserHistory.push('/gift/details');
        }}
        className='gift-compliance__toolbar'
        showBackButton
      />
      <IconBanner
        className='gift-compliance__banner'
        title={localized['giftCompliance.banner.title'] || ''}
        description={localized['giftCompliance.banner.description'] || ''}
        imgSrc={ShieldImg}
        imgAlt={localized['img.alt.shieldIcon']}
      />
      {selectedOccasion && (
        <img
          src={selectedOccasion?.cardImage || ''}
          alt={selectedOccasion?.cardImageAlt || ''}
          className='gift-compliance__occasion-card'
        />
      )}
      <div className='gift-compliance__avatar'>
        {profilePictureUrl ? (
          <Avatar
            alt={getInitials(firstName, lastInitial)}
            src={profilePictureUrl}
          />
        ) : (
          <Avatar>{getInitials(firstName, lastInitial) || <PermIdentityIcon />}</Avatar>
        )}
      </div>
      <div className='gift-compliance__content'>
        <section className='gift-compliance__content__relationship'>
          <h2 className='gift-compliance__content__relationship__heading'>
            {localized['giftCompliance.relationship.heading'] || ''}
          </h2>
          <Dropdown
            fieldId={shortid.generate()}
            value={relationship}
            label={localized['giftCompliance.relationship.dropdown.label'] || ''}
            onSelect={e => updateRelationship(e.target.value)}
            items={getRelationshipOptions(localized)}
            error={localized[relationshipError?.message]}
            showErrorMessage
          />
        </section>
      </div>
      <Button
        size='large'
        variant='tonal'
        className='gift-compliance__btn'
        onClick={onComplianceNext}
      >
        {localized['continue'] || ''}
      </Button>
    </div>
  );
}

export default GiftCompliance;
